<form class="form" [formGroup]="settingsForm">
  <div class="form__horizontal-fields">
    <div class="form__field">
      <div class="form__field-inner-wrapper">
        <osp-form-field>
          <osp-label [switchControl]="toggleOperatingHoursInput" [tooltip]="operatingHoursInputExplanation">
            {{ operatingHoursInputLabel }}
          </osp-label>
          <osp-input-number
            [minFractionDigits]="0"
            [maxFractionDigits]="0"
            [maxLength]="7"
            [formControlName]="controlNames.SETTINGS_TIMEFENCING_HOURS"
          ></osp-input-number>
          <osp-error
            [messages]="{
              required: 'shared.validation.requiredField' | translate,
              min: 'shared.validation.number.greaterThanZero' | translate
            }"
          />
        </osp-form-field>
      </div>
    </div>

    <div class="form__field">
      <div class="form__field-inner-wrapper">
        <osp-form-field>
          <osp-label [switchControl]="toggleDistanceInput" [tooltip]="distanceInputExplanation">
            {{ distanceInputLabel }}
          </osp-label>
          <osp-input-number
            [minFractionDigits]="0"
            [maxFractionDigits]="0"
            [maxLength]="7"
            [formControlName]="controlNames.SETTINGS_TIMEFENCING_DISTANCE"
          />
          <osp-error
            [messages]="{
              required: 'shared.validation.requiredField' | translate,
              min: 'shared.validation.number.greaterThanZero' | translate
            }"
          />
        </osp-form-field>
      </div>
    </div>
  </div>
  <p class="font-bold text-lg timefence-data-heading">
    {{ "modules.notification.alarmRuleAddEdit.timefenceDescription" | translate }}
  </p>
  <div class="form__timefence-week-container pb-3">
    <osp-timefence-week [formControlName]="controlNames.SETTINGS_TIMEFENCING_WEEK_DAY" />
    <osp-error
      class="form__timefence-week-container-errors"
      [errors]="$timefenceWeekErrors()"
      [messages]="{
        weekDayRequired: 'shared.validation.requiredField' | translate
      }"
    />
  </div>
</form>
